import { REMEMBER_IDENTIFIER_COOKIE } from '@/components/auth/constants';
import { getCookie, removeCookie, setCookie } from '@/utils/auth';

const REMEMBER_DAYS = 30;

export function getRememberedIdentifier(): string | null {
  return getCookie(REMEMBER_IDENTIFIER_COOKIE);
}

export function setRememberedIdentifier(identifier: string): void {
  const expires = new Date();
  expires.setDate(expires.getDate() + REMEMBER_DAYS);
  setCookie(REMEMBER_IDENTIFIER_COOKIE, identifier.trim(), expires.toUTCString());
}

export function clearRememberedIdentifier(): void {
  removeCookie(REMEMBER_IDENTIFIER_COOKIE);
}
